const routes = {
  mediaPlanning: 'media-planning',
  fairValue: 'fair-value',
  digitalFairValue: 'digital-fair-value',
};

export default routes;
